






import Vue from 'vue'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'

interface ComponentData {
  value: string
}

export default Vue.extend({
  name: 'AdditionalFieldsText',

  props: {
    item: {
      type: Object as () => AdditionalField
    }
  },

  data (): ComponentData {
    return {
      value: ''
    }
  },

  watch: {},

  methods: {
    onValueChange (value: string): void {
      const payload: AdditionalFieldItem = {
        parentType: this.item.type,
        componentId: this.item.componentId,
        value: value,
        designation: '',
        id: 0,
        groupId: this.item.groupId,
        project: this.item.project
      }
      this.$emit('onValueChange', payload)
    }
  },

  created () {
    if(this.item) {
      this.value = this.item.value
    }
  }

})
